import React from "react";

const PricingToggler = ({ isMonthly, setIsMonthly }) => {
  return (
    <div className="flex items-center bg-[#28A6CC4F] rounded-full p-1 gap-3.5">
      {/* Monthly Option */}
      <button
        onClick={() => setIsMonthly(true)}
        className={`px-6 py-3.5 rounded-full  text-sm font-semibold transition-all duration-300 ${
          isMonthly
            ? "bg-secondary text-white shadow-md"
            : "text-gray-800 hover:text-gray-900"
        }`}
      >
        Monthly
      </button>

      {/* Yearly Option */}
      <button
        onClick={() => setIsMonthly(false)}
        className={`flex items-center gap-2  px-6 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 ${
          !isMonthly
            ? "bg-secondary text-white shadow-md"
            : "text-gray-800 hover:text-gray-900"
        }`}
      >
        Yearly
        <span
          className={`text-xs px-2 py-1.5  rounded-full font-semibold transition-all duration-300 ${
            !isMonthly ? "bg-[#0303033B] text-white" : "bg-white text-gray-800 "
          }`}
        >
          -10%
        </span>
      </button>
    </div>
  );
};

export default PricingToggler;
